var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardinals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assets / Logo Icons / NFL / Cardinals") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets-/-Logo-Icons-/-NFL-/-Cardinals",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ARI",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 70 0 70 70 0 70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.19098,52.24828 C59.82312,51.32834 51.15754,52.22448 46.21484,62.6843 C46.21484,62.6843 37.76304,52.5917 26.0197,50.81846 C26.48058,45.20292 19.04322,43.7101 17.62026,34.04898 C17.62026,34.04898 11.84246,29.31642 8.95356,21.86352 L10.49188,22.35786 C10.49188,22.35786 8.24558,19.86922 6.5184,15.5799 L8.14464,16.11708 C8.14464,16.11708 6.49936,13.88632 5.60014,7.48748 C25.53278,21.20258 36.03362,16.41654 48.15706,23.27878 C56.38556,27.9412 58.34556,33.35472 59.0345,38.75872 C59.0345,38.75872 65.1259,44.2792 64.19112,52.248",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.35938,51.07998 C63.49,44.29726 58.16482,39.47916 58.16482,39.47916 C57.58984,35.1911 56.03262,28.98966 47.73412,24.4104 C35.13314,17.46248 28.16142,23.13752 8.29654,10.96396 C8.70996,13.23994 10.01896,16.38938 11.68678,18.3456 L9.63298,17.67178 C11.12608,20.8201 13.51728,23.67596 14.7693,24.60304 L12.46714,23.87924 C14.9058,29.86676 19.67042,33.41324 19.67042,33.41324 C20.75612,42.58002 27.4771,44.14172 28.02002,49.7798 C36.7759,51.13822 46.0306,60.51892 46.0306,60.51892 C50.876,52.18528 57.63268,50.5701 63.35938,51.07998",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1458,39.28204 C50.24166,42.34832 47.0225,41.49376 45.87492,37.6705 L48.19598,37.8119 C46.16108,36.59376 44.3128,34.80148 42.88382,33.03538 C42.46326,41.48186 50.40784,45.2732 53.0355,39.3414 C52.73856,39.33902 52.44162,39.31886 52.1458,39.28204",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.68048,25.5598 C37.55164,20.55396 26.39504,23.80448 12.1394,14.9681 C13.55172,19.19078 22.37536,24.136 22.37536,24.136 L14.56742,21.59626 C16.55598,25.0488 24.6953,29.3748 24.6953,29.3748 L17.41362,27.02042 C20.42964,32.03228 27.27186,35.41468 27.27186,35.41468 L23.06682,35.11046 C23.61086,39.82272 30.11806,43.8802 30.46372,47.51698 C33.40722,48.64244 37.20024,50.60468 40.15676,53.14806 C45.8087,50.36822 44.25022,40.9626 33.47372,27.62074 C48.29608,28.51688 47.88742,39.5115 56.39508,37.93076 C55.77138,34.97732 55.36874,30.32806 46.68062,25.5598",
    id: "Path",
    fill: "#97233F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2951,49.33054 C60.21988,47.26372 55.86042,45.1542 50.5589,44.51832 C52.8171,43.89084 55.38764,42.50498 56.44128,40.34912 C58.6887,41.7718 61.81882,45.84104 62.2951,49.3304 L62.2951,49.33054 Z M50.94852,52.21258 C51.82156,49.2366 50.2334,46.53516 50.2334,46.53516 C54.87916,46.08002 60.0061,48.237 62.08132,49.99358 C58.83724,49.33866 54.39574,50.27638 50.94852,52.21244 L50.94852,52.21258 Z",
    id: "Shape",
    fill: "#FFB612",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1458,39.28204 C50.24166,42.34832 47.0225,41.49376 45.87492,37.6705 L48.19598,37.8119 C46.16108,36.59376 44.3128,34.80148 42.88382,33.03538 C42.46326,41.48186 50.40784,45.2732 53.0355,39.3414 C52.73856,39.33902 52.44162,39.31886 52.1458,39.28204",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardinals);
export default __webpack_public_path__ + "static/media/Cardinals.ad297c911e0b20afb3a5764ab2d335ab.svg";
export { ForwardRef as ReactComponent };